export default [
  {
    title: `Sobre a PicPay`,
    text: `A PicPay surgiu para transformar o mercado de empréstimo consignado, oferecendo uma plataforma digital segura e de contratação simples.`,
  },
  {
    title: `O que é o empréstimo consignado da PicPay?`,
    text: `
    O empréstimo consignado é mais fácil de ser contratado e possui taxas mais baixas, uma vez que o valor é descontado diretamente da folha de pagamento ou do benefício pago pela previdência.
    <br />
    Além disso, a contratação é bastante simples, com um processo rápido e menos burocrático.
    `,
  },
  {
    title: `Quais são as etapas de solicitação da oferta pré-aprovada?`,
    text: `
      Após selecionar a sua oferta em nossa plataforma, você será direcionado para o site de nossa parceira:
      <ol>
        <li>Preencha os dados básicos, como nome, telefone, data de nascimento, entre outros.</li>
        <li>Envio da documentação.</li>
        <li>Realização de simulação e escolha dos valores.</li>
        <li>Assinatura do contrato.</li>
        <li>Aprovação do empréstimo.</li>
      </ol>
    `,
  },
  {
    title: `Qual a documentação necessária para contratar?`,
    text: `
      São necessários apenas dois documentos para prosseguir com a oferta:
      <ol>
        <li>Documento de Identtidade.</li>
        <li>Contracheque/Folha de pagamento.</li>
      </ol>
    `,
  },
  {
    title: `Quais são os requisitos para pedir um empréstimo?`,
    text: `Os requisitos para pedir um empréstimo são:
      <ul>
        <li>Ter idade entre 18 e 78 anos.</li>
        <li>Ser aposentado, pensionista do INSS, militar ou servidor público.</li>
      </ul>
    `,
  },
]
